<template>
  <div class="anyrefundList_box">
    <div class="topHeader clear">
      <header class="mint-header is-fixed"
              style="background-color: rgb(57, 60, 65);">
        <div class="mint-header-button is-left"
             @click="geturl">
          <i class="mintui mintui-back"></i>
        </div>
        <h1 class="mint-header-title">{{$t('anyrefundList_title')}}</h1>
        <div class="mint-header-button is-right">
          <i class="iconfont icon-menu1"
             @click="sheetVisible=true"
             slot="right"> </i>
          <actionsheet :actions="actions"
                       v-model="sheetVisible" :cancelText="$t('cancel')"></actionsheet>
        </div>
      </header>
    </div>
    <div class="search">
      <div class="searchBox">
        <input class="orderNumer"
               type="text"
               name=""
               id=""
               placeholder="凭证号 / 订单ID"
               v-model='searchOption.taNo'>
        <div class="searchResult"
             @click='search'>查询</div>
      </div>
    </div>
    <div class="orderList"
         v-for='item in listInfo'
         :key='item.id'>
      <div class="blueLind"></div>
      <div class="infoL">
        <div class="lineInfo">
          <div class="titleThird nomalL">{{$t('anyrefundList_id')}}</div>&nbsp;:
          <span>{{item.id}}</span>
        </div>
        <div class="lineInfo">
          <div class="titleThird nomalL">{{$t('v')}}</div>&nbsp;:
          <span>{{item.feeCode}}</span>
        </div>
        <div class="lineInfo">
          <div class="titleThird nomalL">{{$t('anyrefundList_totalMoney')}}</div>&nbsp;:
          <span>{{item.totalMoney}}</span>
        </div>
        <div class="lineInfo">
          <div class="titleThird nomalL">{{$t('anyrefundList_createDate')}}</div>&nbsp;:
          <span>{{item.createDate | fd}}</span>
        </div>
      </div>
      <div class="infoL infoR">
        <div class="lineInfo">
          <div class="titleThird nomalL">{{$t('anyrefundList_taNo')}}</div>&nbsp;:
          <span>{{item.taNo | fitOrderNo}}</span>
        </div>
        <div class="lineInfo">
          <div class="titleThird nomalL">{{$t('anyrefundList_feeName')}}</div>&nbsp;:
          <span>{{item.feeName}}</span>
        </div>
        <div class="lineInfo">
          <div class="titleThird nomalL">{{$t('anyrefundList_payMoney')}}</div>&nbsp;:
          <span>{{item.payMoney}}</span>
        </div>
        <div class="lineInfo">
          <div class="titleThird nomalL">{{$t('anyrefundList_status')}}</div>&nbsp;:
          <span>{{item.status}}</span>
        </div>
      </div>

      <div class="returnPay">
        <div class="returnButton detailButton"
             @click='openDetail(item)'>{{$t('anyrefundList_detail')}}</div>
        <div class="returnButton"
             @click='showAlter(item)'>{{$t('anyrefundList_alter')}}</div>

        <!--<div class="iconfont icon-you"></div>-->
      </div>
      <!-- <i  class="mintui mintui-back" @click='openDetail(item)'></i> -->

    </div>

    <div>
      <img class="nothing"
           src="../../../assets/images/nothing.png"
           v-if="isEmpty || isFrist">
      <p class="nothingTxt"
         v-if="isEmpty">{{$t('anyrefundList_nothing')}} </p>
      <p class="nothingTxt"
         v-if="isFrist">{{$t('anyrefundList_nothingTxt')}} <br> {{$t('anyrefundList_nothingTxt1')}}</p>
      <img class="nothing"
           src="../../../assets/images/chenggong.png"
           v-if="isSucceed">
      <p class="nothingTxt"
         v-if="isSucceed">{{$t('anyrefundList_alter_success')}}</p>
    </div>
    <mt-popup v-model="popupVisible"
              position="right"
              style="width:100%;height:100%"
              modal='false'>
      <div class="topHeader">
        <header class="mint-header is-fixed"
                style="background-color:rgb(57, 60, 65);">
          <div class="mint-header-button is-left">
            <a class="router-link-exact-active router-link-active"
               @click='openDetail'>
              <i class="mintui mintui-back"></i>
            </a>
          </div>
          <h1 class="mint-header-title">{{$t('anyrefundList_order_detail')}}</h1>
          <div class="mint-header-button is-right">
          </div>
        </header>
      </div>
      <anypayMasterList ref="masterListC"></anypayMasterList>
    </mt-popup>
  </div>
</template>
<script>
import moment from "moment";
import anypayMasterList from "../../common/anypayMasterList";
import {  Actionsheet } from "mint-ui";
import { getTransModel } from "../../../assets/js/anypay";
export default {
  data() {
    return {
      listInfo: [],
      isEmpty: false,
      isFrist: true,
      isSucceed: false,
      popupVisible: false,
      currentItem: {},
      searchOption: {
        //createDate:"2018-01-29",
        taNo: "",
        feeCode: "",
        status: "O",
        //currentPage: 1,
        pageSize: 100,
        pageIndex: 1
      },
      sheetVisible: false,
      actions: []
    };
  },
  mounted() {
    this.actions = [];
    this.actions.push({
      name: this.$t("anyrefundList_action_anpay"),
      method: () => {
        this.$router.push("/anypay/anypay");
      }
    });
    this.actions.push({
      name: this.$t("anyrefundList_action_RefundList"),
      method: () => {
        this.$router.push("/anypay/Search?redirect=/anypay/RefundList");
      }
    });
  },
  methods: {
    geturl() {
      return this.$router.push(this.$route.query.redirect || '/anypay/anypay');
    },
    notsees() {
      this.popupVisible = false;
    },
    fork() {
      this.showTwo = false;
    },
    showAlter(item) {
      this.currentItem = item;
      this.confirm2(this.$t("MessageBox_showAlter"),action => {
        // 点击确定后撤销订单
        this.refundOrder();
      });

      // this.showTwo=! this.showTwo;
    },
    openDetail(item) {
      this.popupVisible = !this.popupVisible;
      this.$refs.masterListC.getMasterList(item.id);
    },
    //调用硬件退款
    refundSucceed(value) {
      if (value.transData.resCode == "00") {
        this.checkOutRevoke(value.transData);
      } else {
        this.msg2(value.transData.resDesc);
      }
    },
    // 硬件退款
    refundOrder() {
      //流水号
      var traceNo = this.currentItem.taNo;
      var paycodeDesc = this.currentItem.taWay;
      var tr =
        traceNo != null && traceNo.indexOf("_") > 0
          ? traceNo.split("_")[1]
          : traceNo;
      var transData = {
        sceneCode: "anypay",
        totalFee: Number(this.currentItem.totalMoney),
        transType: "04",
        transMode: getTransModel(paycodeDesc),
        authCode: null,
        orgGcsn: tr,
        refundId: tr + "_T",
        hotelOutId: this.currentItem.orderNo,
        descript: this.$t("anyrefundList_scene")
      };
      this.$http.post("/mobilepmsapi/gcpay/pay", transData).then(res => {
        if (res.data.result == 0) {
          if (res.data.retVal.status == "SUCCESS") {
            this.checkOutRevoke(this.currentItem);
          } else {
            this.msg2(this.$t("msg_refundOrder_sta") + res.data.retVal.status);
          }
        } else {
          this.msg2(res.data.msg);
        }
      });
    },
    // 撤销ding'dan
    checkOutRevoke(data) {
      this.$http
        .post("/mobilepmsapi/pay/cancelOrder", {
          id: this.currentItem.id,
          cancel_money: data.amt,
          remark: data.traceNo
        })
        .then(res => {
          if (res.data.result == 0) {
            // 校验用户信息成功，开始执行入账程序
            this.msg2(this.$t("msg_checkOutRevoke"));
            (this.isEmpty = false), (this.isFrist = false);
            this.isSucceed = true;
            this.listInfo = [];
          } else {
            this.msg2(res.data.msg);
          }
        });
    },
    search() {
      if (this.searchOption.taNo == "") {
        this.msg2(this.$t("msg_anyrefundList_search"));
      } else {
        this.getInfo();
      }
    },
    getInfo() {
      this.$http
        .post("/mobilepmsapi/pay/findPageList", this.searchOption)
        .then(res => {
          if (res.data.result == 0) {
            this.listInfo = res.data.retVal.list;
            this.isEmpty = false;
            this.isFrist = false;
            this.isSucceed = false;
            if (this.listInfo.length == 0) {
              this.isEmpty = true;
            }
          } else {
            this.msg2(res.data.msg);
          }
        });
    }
  },
  filters: {
    tofixed(v) {
      return parseFloat(v).toFixed(2);
    },
    fitOrderNo(v) {
      return v != null && v.indexOf("_") > 0 ? v.split("_")[0] : v;
    },
    fd(value) {
      if (value == null || value == "") return "";
      return value.substr(11);
    }
  },
  components: {
    anypayMasterList,
    actionsheet: Actionsheet
  }
};
</script>
<style lang='less'>
.anyrefundList_box {
  text-align: center;
  .topHeader {
    height: 40px;
    .mintui-back {
      font-size: 0.64rem;
    }
    .icon-menu1 {
      font-size: 0.5rem;
      padding: 0.3rem 0.1rem;
    }
  }
  .topHeader .mint-header {
    color: #fff;
    font-size: 16px;
    z-index: 100;
  }
  .refundTop {
    width: 100%;
    height: 1.28rem;
    background: #fff;
    .data {
      width: 59%;
      height: 1.0667rem;
      margin-top: 0.1067rem;
      display: inline-block; // background: blue;
      .iconBox {
        border-radius: 2.6667rem;
        width: 0.8533rem;
        height: 0.8533rem;
        display: inline-block;
        text-align: center;
        background: #fff;
        -moz-transform: none;
        -webkit-transform: none;
        -o-transform: none;
        -ms-transform: none;
        transform: none;
        .icon-jiantou,
        .icon-caret-right-copy {
          font-size: 0.32rem;
          line-height: 0.88rem;
          color: #d8d8d8;
          transform: scale(0.7);
          margin-left: 0.1067rem;
        }
        .icon-jiantou {
          margin-left: 0rem;
        }
      }
      .blakBg {
        background: #f6f8f9 !important;

        border-radius: 2.6667rem;
      }
      .fontBlack {
        color: black !important;
      }
      .dataDtail {
        display: inline-block;
        font-size: 0.3733rem;
        color: #393c41;
        margin: 0.2667rem 0.3733rem 0rem;
      }
    }
  }
  .search {
    width: 100%;
    border-radius: 0.2667rem;
    background: #f4f5f7;
    margin: 0 auto 0 auto;
    height: 1.6rem;
    .searchBox {
      height: 0.8rem;
      margin: 0 auto;
      width: 96%;
      padding-top: 0.4rem;
      .tableNuber {
        width: 21%;
        height: 0.7733rem;
        font-size: 0.3733rem;
        padding-left: 0.2667rem;
        background: #fff;
        border: 0.0267rem solid #cccccc;
        border-radius: 0.1333rem;
        margin-left: 0.1333rem;
        float: left;
      }
      .orderNumer {
        width: 68%;
        height: 0.7733rem;
        font-size: 0.3733rem;
        padding-left: 0.2667rem;
        background: #fff;
        border: 0.0267rem solid #cccccc;
        border-radius: 0.1333rem;
        float: left;
        margin-left: 0.2667rem;
      }
      .searchResult {
        width: 20.5%;
        height: 0.7733rem;
        font-size: 0.3733rem;
        background: #d8af68;
        border-radius: 0.1867rem;
        float: right;
        color: #fff;
        line-height: 0.7467rem;
        margin-right: 0.08rem;
        margin-top: 0.0533rem;
      }
    }
  }

  .orderList {
    background: #ffffff;
    margin-bottom: 0.2667rem;
    width: 96%;
    height: auto;
    margin: 0 auto 0.2667rem;
    box-shadow: 0 0 0.2133rem 0rem #dadada;
    border-radius: 0.1333rem;
    position: relative;
    .mintui {
      position: absolute;
      top: 40%;
      right: 5%;
      transform: rotate(180deg);
    }
    .blueLind {
      height: 0.3733rem;
      width: 0.9%;
      background: #646f83;
      display: inline-block;
      float: left;
      margin-top: 0.48rem;
    }
    .infoL {
      width: 52%;
      height: auto;
      text-align: left;
      display: inline-block;
      padding-top: 0.3733rem;
      text-indent: 0.1533rem;
      .lineInfo {
        margin: 0.2rem 0;
        color: #999999;
        .titleThird {
          display: inline-block;
          color: #999999;
          letter-spacing: 0.2667rem;
        }
        .titileS {
          display: inline-block;
          color: #999999;
        }
        .nomalL {
          letter-spacing: 0rem;
        }

        span {
          margin-left: 0.1333rem;
          font-size: 0.3733rem;
          color: #151515;
        }
      }
    }
    .infoR {
      width: 45%;
    }
    .infoBo {
      text-align: left;
      margin-left: 0.3733rem;
      margin-bottom: 0.2133rem;
      .titleThird {
        display: inline-block;
        color: #999999;
        letter-spacing: 0.2667rem;
      }
      .titileS {
        display: inline-block;
        color: #999999;
      }
      .nomalL {
        letter-spacing: 0rem;
      }
      span {
        margin-left: 0.1333rem;
        font-size: 0.3733rem;
        color: #151515;
      }
      b {
        font-size: 0.32rem;
        color: #4990e2;
        text-decoration: underline;
        margin-left: 0.1333rem;
      }
    }
    .returnPay {
      width: 94%;
      height: 1.2rem;
      border-top: 0.0267rem solid #eeeeee;
      margin: 0 auto;
      .returnButton {
        float: right;
        width: 33%;
        height: 0.8267rem;
        background: #ff8902;
        border-radius: 0.1867rem;
        color: #fff;
        font-size: 0.3733rem;
        line-height: 0.7467rem;
        margin-top: 0.2133rem;
      }
      .detailButton {
        float: left;
        background: #2d8cf0;
      }
      .icon-you {
        float: right;
        font-size: 0.3733rem;
        line-height: 1.1733rem;
        margin-right: 0.08rem;
      }
    }
  }
}

.nothing {
  width: 80px;
  height: 88px;
  margin: 150px auto 0 auto;
}
.nothingTxt {
  text-align: center;
  font-size: 20px;
  color: #ccd1d5;
  margin-top: 20px;
}
.show {
  display: block;
}
.hide {
  display: none;
}
.restaurantDetail_box {
  overflow: auto;
  height: 100%;
  .DetailTop {
    width: 90%;
    height: 1.2533rem;
    margin: 0 auto;
    font-size: 0.32rem;
    color: #333333;
    .topL {
      float: left;
      line-height: 1.2267rem;
    }
    .topR {
      float: right;
      line-height: 1.2267rem;
      span {
        display: inline-block;
      }
      .circleBox {
        width: 0.5333rem;
        height: 0.5333rem;
        background: #646f83;
        border-radius: 1.36rem;
        color: #fff;
        display: inline-block;
        vertical-align: top;
        margin-top: 0.3733rem;
        line-height: 0.5867rem;
      }
    }
  }
  .mint-popup-right {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// anypayRefundList.vue?4d46a1b5